import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import site from "../content/site.json";

export default function ObjectionFAQ({ title = "Common questions", className = "" }) {
  return (
    <div className={className} data-testid="objection-faq">
      <h2 className="font-heading text-xl sm:text-2xl font-bold text-slate-900 text-center">{title}</h2>
      <Accordion type="single" collapsible className="mt-6 max-w-3xl mx-auto">
        {site.pricing_faq.map(([q, a], i) => (
          <AccordionItem key={i} value={`q${i}`} data-testid={`objection-faq-${i}`}>
            <AccordionTrigger className="text-left font-semibold text-slate-800">{q}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
